import { render, staticRenderFns } from "./editQuotation.vue?vue&type=template&id=5bde7514&scoped=true&"
import script from "./editQuotation.vue?vue&type=script&lang=js&"
export * from "./editQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde7514",
  null
  
)

export default component.exports